import Api from "../api/api";

export default async (data) => {
  console.log("data", data);
  return await Api.post("profile/change-image", data);
};
